import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastMessage {
  severity: 'success' | 'info' | 'warn' | 'error';
  summary: string;
  detail?: string;
  life?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private messageSubject = new Subject<ToastMessage>();
  message$ = this.messageSubject.asObservable();

  success(summary: string, detail?: string, life: number = 3000): void {
    this.show('success', summary, detail, life);
  }

  error(summary: string, detail?: string, life: number = 5000): void {
    this.show('error', summary, detail, life);
  }

  warn(summary: string, detail?: string, life: number = 4000): void {
    this.show('warn', summary, detail, life);
  }

  info(summary: string, detail?: string, life: number = 3000): void {
    this.show('info', summary, detail, life);
  }

  private show(
    severity: ToastMessage['severity'],
    summary: string,
    detail?: string,
    life?: number,
  ): void {
    this.messageSubject.next({ severity, summary, detail, life });
  }
}
